import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './ImportProdutoMassa.css'
import {
  PageHeader,
  Btn,
  ExcelModeloBuilder,
  ImportExcelFile,
  CustomCheckbox,
  CustomPanel,
  SelectEmpresas,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveProductsMassively } from '../../../../services/api/https/system/system.http'
import { getProdutosSemEanOnExcel } from '../../../../services/api/https/registration/produto.http'

const COLS = [
  'codigo_produto (string)*',
  'descricao_produto (string)*',
  'peso_bruto (KG)(decimal)*',
  'unidades_por_sku (int)*',
  'qte_por_pallet (int)',
  'm3_sku (decimal)*',
  'dias_para_vencimento (int)',
  'ordem_separacao (int)',
  'ean_item (string)*',
  'dun14 (string)',
  'ativo (0,1)*',
  'caixa_com_peso_variavel (0,1)',
  'participa_calculo_paletizacao (0,1)',
  'peso_liquido (KG)(decimal)',
  'grupo_produto (string)*',
  'unidade_agregadora (string)',
  'unidade_fracionada (string)',
  'picking_lote_obrigatorio (0,1)',
  'picking_validade_obrigatoria (0,1)',
  'picking_receb_lote_obrigatorio (0,1)',
  'picking_receb_validade_obrigatoria (0,1)',
  'picking_receb_fabricacao_obrigatoria (0,1)',
  'picking_receb_info_complementar_obrigatoria (0,1)',
  'estoque_minimo (decimal)',
  'inventario_lote_obrigatorio (0,1)',
  'inventario_validade_obrigatoria (0,1)',
]

class ImportProdutoMassa extends Component {
  modeloExcel = [COLS]

  state = {
    loading: false,
    produtos: [],
    company_id: '',
  }

  onBtnSalvarClicked = async () => {
    this.props.dispatch(showLoadingBox('Aguarde...', 'Carregando...'))
    try {
      const { company_id, produtos } = this.state

      if (!company_id) {
        throw new Error('Selecione a Empresa Desejada')
      }
      if (produtos.length === 0) {
        throw new Error('Não existem Produtos para Importação')
      }

      const message = await saveProductsMassively(produtos)
      this.props.dispatch(showMessageBox(message, null))
      this.setState({ produtos: [] })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      this.props.dispatch(hideLoadingBox())
    }
  }

  onBtnVoltarClicked = () => this.props.history.goBack()

  onBtnExportarClicked = async () => {
    try {
      if (!this.state.company_id) {
        throw new Error('Selecione a empresa antes de exportar a planilha.')
      }

      window.open(await getProdutosSemEanOnExcel(this.state.company_id))
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onFileImported = content => {
    try {
      if (!this.state.company_id) {
        throw new Error('Selecione a empresa antes de importar a planilha.')
      }

      this._assertHeader(content[0])
      this.setState({ produtos: this._buildProdutos(content) })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error.message))
    }
  }

  onEmpresaChange = value => {
    const { id } = value

    const produtos = this.state.produtos.map(p => ({ ...p, company_id: id }))
    this.setState({ company_id: id, produtos })
  }

  render() {
    const { company_id, produtos } = this.state

    return (
      <div>
        <PageHeader>
          <span>S.8 - Importação de Produtos em Massa</span>
        </PageHeader>

        <div style={{ marginTop: 20 }}>
          <CustomPanel showBtnNovo={false} onVoltar={this.onBtnVoltarClicked}>
            <div className="p-grid" style={{ marginBottom: 15 }}>
              <div className="p-col-12 p-md-3">
                <SelectEmpresas companyId={company_id} onChange={this.onEmpresaChange} />
              </div>

              <div
                className="p-col-12 p-md-9"
                style={{ display: 'flex', alignItems: 'flex-end', gap: 10, flexWrap: 'wrap' }}
              >
                <Btn onClick={this.onBtnExportarClicked}>Exportar (sem EAN)</Btn>

                <ExcelModeloBuilder
                  modeloColunas={this.modeloExcel}
                  filename="ImportacaoProdutos.xlsx"
                />

                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  onFileImported={this.onFileImported}
                />

                <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
              </div>
            </div>

            <div className="ImportProdutoMassa__tableWrapper">
              <DataTable
                value={produtos}
                emptyMessage="Nenhum produto importado."
                style={{ minWidth: 2700 }}
              >
                <Column field="product_code" header="Código" style={tableCellCentered(80)} />
                <Column field="name" header="Produto" />
                <Column field="weight" header="Peso Bruto - KG" style={tableCellCentered()} />
                <Column field="unit_sku" header="Unid. por Sku" style={tableCellCentered()} />
                <Column
                  field="qte_por_pallet"
                  header="Qte. por pallet"
                  style={tableCellCentered()}
                />
                <Column field="m3" header="M3 por Sku" style={tableCellCentered()} />
                <Column
                  field="dias_para_vencimento"
                  header="Dias para vencimento"
                  style={tableCellCentered()}
                />
                <Column
                  field="ordem_separacao"
                  header="Ordem de Separação"
                  style={tableCellCentered()}
                />
                <Column field="ean" header="EAN" style={tableCellCentered(150)} />
                <Column field="dun14" header="DUN14" style={tableCellCentered(150)} />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.actived} />}
                />
                <Column
                  field="caixa_com_peso_variavel"
                  header="Cx. com Peso Variável"
                  style={tableCellCentered(80)}
                  body={p => <CustomCheckbox disabled checked={!!p.caixa_com_peso_variavel} />}
                />
                <Column
                  field="participa_calculo_paletizacao"
                  header="Participa Cálculo Paletização"
                  style={tableCellCentered()}
                  body={p => (
                    <CustomCheckbox disabled checked={!!p.participa_calculo_paletizacao} />
                  )}
                />
                <Column
                  field="weight_liquido"
                  header="Peso Líquido - KG"
                  style={tableCellCentered()}
                />
                <Column
                  field="grupo_produto_nome"
                  header="Grupo de Produto"
                  style={tableCellCentered()}
                />
                <Column
                  field="un_agregadora"
                  header="Unidade Agregadora"
                  style={tableCellCentered()}
                />
                <Column
                  field="un_fracionada"
                  header="Unidade Fracionada"
                  style={tableCellCentered()}
                />
                <Column
                  field="estoque_minimo"
                  header="Estoque Mínimo"
                  style={tableCellCentered()}
                />
                <Column
                  field="picking_add_lote"
                  header="Picking Lote Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.picking_add_lote} />}
                />
                <Column
                  field="picking_add_data_validade"
                  header="Picking Validade Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.picking_add_data_validade} />}
                />
                <Column
                  field="picking_add_lote_recebimento"
                  header="Receb. Lote Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.picking_add_lote_recebimento} />}
                />
                <Column
                  field="picking_add_data_validade_recebimento"
                  header="Receb. Validade Obrig."
                  style={tableCellCentered()}
                  body={p => (
                    <CustomCheckbox disabled checked={!!p.picking_add_data_validade_recebimento} />
                  )}
                />
                <Column
                  field="picking_add_data_fabricacao"
                  header="Receb. Fabricação Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.picking_add_data_fabricacao} />}
                />
                <Column
                  field="picking_add_info_complementar"
                  header="Receb. Info Compl. Obrig."
                  style={tableCellCentered()}
                  body={p => (
                    <CustomCheckbox disabled checked={!!p.picking_add_info_complementar} />
                  )}
                />
                <Column
                  field="inventario_add_lote"
                  header="Invent. Lote Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.inventario_add_lote} />}
                />
                <Column
                  field="inventario_add_data_validade"
                  header="Invent. Validade Obrig."
                  style={tableCellCentered()}
                  body={p => <CustomCheckbox disabled checked={!!p.inventario_add_data_validade} />}
                />
              </DataTable>
            </div>
          </CustomPanel>
        </div>
      </div>
    )
  }

  _assertHeader = (headerRow = []) => {
    for (let i = 0; i < COLS.length; i += 1) {
      if (headerRow[i] !== COLS[i]) {
        throw new Error(
          `Cabeçalho inválido – coluna ${i + 1} deveria ser "${COLS[i]}", mas recebi "${headerRow[i]}".`,
        )
      }
    }
  }

  _buildProdutos = content => {
    const body = content.slice(1)
    const { company_id } = this.state
    const produtos = []

    const throwErr = (linha, razao) => {
      throw new Error(`Erro na linha ${linha}: ${razao}`)
    }

    for (let r = 0; r < body.length; r += 1) {
      const row = body[r]
      const lineNumber = r + 2

      if (row.every(c => c === undefined || c === null || String(c).trim() === '')) {
        continue
      }

      if (!row[0] || String(row[0]).trim() === '')
        throwErr(lineNumber, 'Código do produto não informado.')
      if (!row[1] || String(row[1]).trim() === '') throwErr(lineNumber, 'Descrição não informada.')
      if (row[2] === undefined || row[2] === '' || isNaN(Number(row[2])))
        throwErr(lineNumber, 'Peso Bruto inválido.')
      if (row[3] === undefined || row[3] === '' || !Number.isInteger(Number(row[3])))
        throwErr(lineNumber, 'Unidades por SKU inválidas.')
      if (row[4] !== undefined && row[4] !== '' && !Number.isInteger(Number(row[4])))
        throwErr(lineNumber, 'Qtde por pallet inválida.')
      if (row[5] === undefined || row[5] === '' || isNaN(Number(row[5])))
        throwErr(lineNumber, 'M3 por SKU inválido.')
      if (![0, 1, '0', '1'].includes(row[10]))
        throwErr(lineNumber, 'Campo "ativo" deve ser 0 ou 1.')
      if (row[11] !== undefined && row[11] !== '' && ![0, 1, '0', '1'].includes(row[11]))
        throwErr(lineNumber, 'Campo "caixa_com_peso_variavel" deve ser 0, 1 ou vazio.')
      if (row[12] !== undefined && row[12] !== '' && ![0, 1, '0', '1'].includes(row[12]))
        throwErr(lineNumber, 'Campo "participa_calculo_paletizacao" deve ser 0, 1 ou vazio.')
      if (row[13] !== undefined && row[13] !== '' && isNaN(Number(row[13])))
        throwErr(lineNumber, 'Peso líquido inválido.')
      if (row[17] !== undefined && row[17] !== '' && ![0, 1, '0', '1'].includes(row[17]))
        throwErr(lineNumber, 'Campo "picking_lote_obrigatorio" deve ser 0, 1 ou vazio.')
      if (row[18] !== undefined && row[18] !== '' && ![0, 1, '0', '1'].includes(row[18]))
        throwErr(lineNumber, 'Campo "picking_validade_obrigatoria" deve ser 0, 1 ou vazio.')
      if (row[19] !== undefined && row[19] !== '' && ![0, 1, '0', '1'].includes(row[19]))
        throwErr(lineNumber, 'Campo "picking_receb_lote_obrigatorio" deve ser 0, 1 ou vazio.')
      if (row[20] !== undefined && row[20] !== '' && ![0, 1, '0', '1'].includes(row[20]))
        throwErr(lineNumber, 'Campo "picking_receb_validade_obrigatoria" deve ser 0, 1 ou vazio.')
      if (row[21] !== undefined && row[21] !== '' && ![0, 1, '0', '1'].includes(row[21]))
        throwErr(lineNumber, 'Campo "picking_receb_fabricacao_obrigatoria" deve ser 0, 1 ou vazio.')
      if (row[22] !== undefined && row[22] !== '' && ![0, 1, '0', '1'].includes(row[22]))
        throwErr(
          lineNumber,
          'Campo "picking_receb_info_complementar_obrigatoria" deve ser 0, 1 ou vazio.',
        )
      if (row[24] !== undefined && row[24] !== '' && ![0, 1, '0', '1'].includes(row[24]))
        throwErr(lineNumber, 'Campo "inventario_lote_obrigatorio" deve ser 0, 1 ou vazio.')
      if (row[25] !== undefined && row[25] !== '' && ![0, 1, '0', '1'].includes(row[25]))
        throwErr(lineNumber, 'Campo "inventario_validade_obrigatoria" deve ser 0, 1 ou vazio.')

      produtos.push({
        product_code: String(row[0]).trim(),
        company_id,
        name: String(row[1]).trim(),
        weight: Number(row[2]),
        unit_sku: Number(row[3]),
        qte_por_pallet: row[4] === '' || row[4] === undefined ? null : Number(row[4]),
        m3: Number(row[5]),
        dias_para_vencimento: row[6] === '' || row[6] === undefined ? null : Number(row[6]),
        ordem_separacao: row[7] === '' || row[7] === undefined ? null : Number(row[7]),
        ean: row[8] !== undefined && String(row[8]).trim() !== '' ? String(row[8]).trim() : null,
        dun14: row[9] !== undefined && String(row[9]).trim() !== '' ? String(row[9]).trim() : undefined,
        actived: Number(row[10]),
        caixa_com_peso_variavel: row[11] === '' || row[11] === undefined ? null : Number(row[11]),
        participa_calculo_paletizacao:
          row[12] === '' || row[12] === undefined ? null : Number(row[12]),
        weight_liquido: row[13] === '' || row[13] === undefined ? null : Number(row[13]),
        grupo_produto_nome: row[14] ? String(row[14]).trim() : undefined,
        un_agregadora: row[15] ? String(row[15]).trim() : undefined,
        un_fracionada: row[16] ? String(row[16]).trim() : undefined,
        picking_add_lote: row[17] === '' || row[17] === undefined ? 0 : Number(row[17]),
        picking_add_data_validade: row[18] === '' || row[18] === undefined ? 0 : Number(row[18]),
        picking_add_lote_recebimento: row[19] === '' || row[19] === undefined ? 0 : Number(row[19]),
        picking_add_data_validade_recebimento:
          row[20] === '' || row[20] === undefined ? 0 : Number(row[20]),
        picking_add_data_fabricacao: row[21] === '' || row[21] === undefined ? 0 : Number(row[21]),
        picking_add_info_complementar:
          row[22] === '' || row[22] === undefined ? 0 : Number(row[22]),
        estoque_minimo: row[23] !== undefined && row[23] !== '' ? Number(row[23]) : null,
        inventario_add_lote: row[24] === '' || row[24] === undefined ? 0 : Number(row[24]),
        inventario_add_data_validade: row[25] === '' || row[25] === undefined ? 0 : Number(row[25]),
      })
    }

    return produtos
  }
}

export default connect()(withRouter(ImportProdutoMassa))
